module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_1.06d8f1e6.png";